module.exports = __webpack_public_path__ + "img/kv3_sp.bec53d43.jpg";